import { urlBase } from "./config";
import axiosInstance from "../services/config/axiosinstance";

async function getList({ idEvent, offset, limit, search, columnSearch = "" }) {
  var config = {
    method: "get",
    url: `${urlBase}/temp/rdnotaveis/report/${idEvent}/event?limit=${limit}&offset=${offset}&columnSearch=${columnSearch}&search=${search}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function getChartData({ idEvent }) {
  var config = {
    method: "get",
    url: `${urlBase}/temp/rdnotaveis/groupingreads/${idEvent}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function getChartDataRdPw({ idEvent }) {
  var config = {
    method: "get",
    url: `${urlBase}/game-completed-items/completedbycompany/${idEvent}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function listGameItemsCompleted({
  idEvent,
  offset,
  limit,
  search,
  columnSearch = "",
}) {
  var config = {
    method: "get",
    url: `${urlBase}/game-completed-items/list/${idEvent}/event?limit=${limit}&offset=${offset}&columnSearch=${columnSearch}&search=${search}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function deleteItemList(idItem) {
  var config = {
    method: "put",
    url: `${urlBase}/game-completed-items/disable/${idItem} `,
    headers: {
      "Content-Type": "application/json",
    },
  };
  // https://gateway-admin-plus.inteegratec.com.br/api-admin-mobile/game-completed-items/disable/03d13a66-3b72-4daf-bc6b-48a1be76b852/event
  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function deleteAllItemList(idEvent) {
  var config = {
    method: "put",
    url: `${urlBase}/game-completed-items/disable/${idEvent}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  // https://gateway-admin-plus.inteegratec.com.br/api-admin-mobile/game-completed-items/disable/a338dd87-646a-4277-acfd-1a54e9eced0f/event

  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

export {
  getList,
  getChartData,
  getChartDataRdPw,
  listGameItemsCompleted,
  deleteItemList,
  deleteAllItemList,
};
